import { useView } from '@hooks';
import { isEstimateOut, isOrderLocked } from '@models';
import { useStore } from '@stores';
import { observer } from 'mobx-react';
import React from 'react';
import Mobile from './OrderServiceSelect.mobile';
import Presentation from './OrderServiceSelect.presentation';
import { IOrderServiceSelectProps } from './OrderServiceSelect.props';

export const OrderServiceSelect: React.FC<IOrderServiceSelectProps> = observer(
  ({
    atLeastOneService = false,
    variant = 'selected',
    basket,
    hideSavedOnlyActions,
    hideHeader,
    pickerOpen,
    onPickerClose,
    actionsSlot,
    headerActions,
    emptyAction,
  }) => {
    const { isMobile } = useView();
    const { orderStore } = useStore();
    const { order } = orderStore;

    // A basket belongs to a job that does not exist yet, so the loaded order's status - which may be
    // some unrelated job the user last opened - must not lock it.
    const disabled =
      !basket &&
      variant !== 'revision' &&
      !!order &&
      (isEstimateOut(order) || isOrderLocked(order.status));

    const props = {
      atLeastOneService,
      disabled,
      variant,
      basket,
      hideSavedOnlyActions,
      hideHeader,
      pickerOpen,
      onPickerClose,
      actionsSlot,
      headerActions,
      emptyAction,
    };

    return isMobile ? <Mobile {...props} /> : <Presentation {...props} />;
  }
);
